import { useInjection } from 'inversify-react';
import { observer } from 'mobx-react-lite';
import { ReactElement } from 'react';
import { IProjectStatsFiltersStore } from '../filters/ProjectStatsFilters.store';
import { GeneralSection } from './GeneralSection';

export const GeneralSectionContainer = observer((): ReactElement => {
  const filtersStore = useInjection(IProjectStatsFiltersStore.$);

  return (
    <GeneralSection
      endDate={filtersStore.endDate}
      startDate={filtersStore.startDate}
    />
  );
});
